import React from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules, getTestId } from '@utils';

import ButtonLink from '@components/ButtonLink';
import CryptoMenu, { TCryptoMenu } from '@components/CryptoMenu';
import MainLayout from '@layouts/MainLayout';

import style from './BalanceLayoutOld.scss';

const cn = bemCssModules(style, 'BalanceLayoutOld');
const ti = getTestId('BalanceLayoutOld');

export type TBalanceLayoutOld = {
  activeTab: TCryptoMenu['activeTab'];
  tabs: TCryptoMenu['tabs'];
  balance?: string | number;
  routes: {
    [key in 'withdraw' | 'topup']: string;
  };
};

const BalanceLayoutOld: CustomFC<TBalanceLayoutOld> = props => {
  const { children, className, activeTab, tabs, balance = 0, routes } = props;

  const { t } = useTranslation();

  const cryptoMenuProps = { activeTab, tabs };

  return (
    <MainLayout className={cn(null, [className])} data-testid={ti()}>
      <div className={cn('container')}>
        <div className={cn('header')}>
          <CryptoMenu className={cn('menu')} {...cryptoMenuProps} />
          <ButtonLink
            data-testid={ti('withdraw-link')}
            to={routes.withdraw}
            disabled={+balance <= 0}
            outline
          >
            {t('operations.send')}
          </ButtonLink>
          <ButtonLink data-testid={ti('topup-link')} to={routes.topup}>
            {t('operations.topup')}
          </ButtonLink>
        </div>
        {children}
      </div>
    </MainLayout>
  );
};

export default BalanceLayoutOld;
